import History from '../../util/history';
import './log';
import Mscratch from '../../services/mscratch';
import ProjectApi from '../../services/api/project';
import UploadAction from '../upload/action';
import UpdaterAction from '../updater/action';
import ProjectAction from '../project/action';
import { isLocal } from '../../util/env';
import { safeHttps } from '../../util';
import Emitter from '../../services/emitter';
import dialog from '../../components/configui/dialog';
import formatMessage from '../../components/configui/lang';
import store from '../../reducers';
import CONSTANT from '../../constant';
import { message } from 'antd';

/**
 * 设置标题
 *
 */
export const setTitle = (store) => {
    setNavigatorTitle(store);
    setProjectname(store);
};

export const setPageThumbnail = (imgSrc) => {
    imgSrc = safeHttps(imgSrc);
    document.querySelector('meta[name=thumbnail]').content = imgSrc;
};

const setNavigatorTitle = (store) => {
    const {
        messages
    } = store.getState().intlr;
    document.title = `${messages['MBLOCK']}`;
};

export const setProjectname = (store) => {
    const {
        intlr,
        project
    } = store.getState();
    const {
        projectId,
        projectType,
        isConfirmName
    } = project;
    if (ProjectAction && !projectId && !isConfirmName) {
        if (projectType === 'example' || projectType === 'local') {
            return;
        }
        let initProjectName = ProjectApi.getNewProjectName(intlr.messages['FILENAME.EMPTY'], project.projects);
        store.dispatch(ProjectAction.saved({
            name: initProjectName,
            // preProjectData: Mscratch.getProjectJsonString(),
        }));
    }
};

/**
 * 撤销
 *
 */
export const onUndo = () => {
    Mscratch.undo();
};

/**
 * 重做
 *
 */
export const onRedo = () => {
    Mscratch.redo();
};

/**
 * 点击上传固件
 *
 */
export const onClickUploadFirmware = () => {
    if (History.location.pathname === '/') {
        History.push('/updater/firmware/progress');
        Emitter.emit('uploadFirmwarePrepare');
    }
};

/**
 * 点击上传代码执行事件
 *
 */
export const uploadCode = (store) => {
    if (History.location.pathname === '/') {
        store.dispatch(UploadAction.uploadCodePrepare());
        History.push('/upload/code');
    }
};

/**
 * 检查更新
 *
 */
export const checkUpdate = (store, isAuto) => {
    store.dispatch(UpdaterAction.checker(isAuto));
};

const handlePageEvt = (event) => {
    event.preventDefault();
    event.returnValue = '';
};

export const listenPageLeave = () => {
    window.addEventListener('beforeunload', handlePageEvt);
};

export const removePageLeave = () => {
    window.removeEventListener('beforeunload', handlePageEvt);
};

export const onbeforeunload = () => {
    if (!isLocal()) {
        listenPageLeave();
    }
};


const uploadFirmware = (url) => {
    return fetch(url).then((res) => {
        console.log(`upload finish fetch ${url}`);
        return res.arrayBuffer();
    }, (error) => {
        Emitter.emit('downloadFirmwareFail', error);
    }).then((data) => {
        Emitter.emit('downloadFirmwareOK', data);
    }, (error) => {
        Emitter.emit('downloadFirmwareFail', error);
    });
};

let paramCache = {
    info: null,
    isReset: false,
    options: {},
};

const uploadFirmwareUI = (info, isReset = false, options = {}) => {
    const { connect, intlr } = store.getState();
    if (connect.type === CONSTANT.CONNECT_TYPE.BLE) {
        message.warning(intlr.messages['CONNECT.FIRMWARE.BLE.WARN']);
        return;
    }

    if (info == null) {
        info = paramCache.info;
        isReset = paramCache.isReset;
        options = paramCache.options;
    } else {
        paramCache = {
            info, isReset, options
        };
    }

    let firmwareOptions = [];
    let factoryFrimware = '';
    if (info.firmware) {
        firmwareOptions = info.firmware.map((data) => {
            const url = typeof data.url === 'string' ? data.url : data.url.url;
            if (!factoryFrimware && data.isFactory) {
                factoryFrimware = url;
            }
            return {
                text: `${formatMessage(data.name)}(${data.version||'-'})`,
                value: url
            };
        });
    }
    dialog('updateFirmware', {
        title: 'MENU.HELP.UPDATEFIRMWARE',
        width: '340px',
        fields: [
            {
                id: 'device',
                label: 'UPDATER.FRIMWARE.F.DEVICE.TEXT',
                type: 'input',
                value: info.name,
                props: {
                    readOnly: true
                }
            },
            {
                id: 'firmware',
                label: 'UPDATER.FRIMWARE.F.VERSION.TEXT',
                type: 'select',
                options: firmwareOptions,
                value: isReset ? factoryFrimware : firmwareOptions[0].value,
                props: {
                    disable: isReset
                }
            }
        ],
        buttons: [
            {
                id: 'cancel',
                type: 'default',
                text: 'BUTTON.CANCEL.TEXT',
                style: {
                    flex: 'auto'
                },
                handle: (ctx) => {
                    ctx.close();
                }
            },
            {
                id: 'update',
                text: 'BUTTON.UPDATE.TEXT',
                style: {
                    flex: 'auto'
                },
                handle: (ctx) => {
                    const {
                        values
                    } = ctx;
                    const {
                        firmware
                    } = values;
                    // History.push(`/updater/firmware/progress?url=${firmware}`);
                    uploadFirmware(firmware).then(() => {
                        ctx.close();
                    });
                }
            }
        ]
    });
};

Emitter.on('ShowUpdateFirmware', (info, options = {}) => {
    uploadFirmwareUI(info, false, options);
});

Emitter.on('ShowResetFactoryFirmware', (info, options = {}) => {
    uploadFirmwareUI(info, true, options);
});